import {RemoteGetCommunications} from 'data/usecases/private/communications/remote-get-communications';
import {GetCommunications} from 'domain/usecases/private/communications/get-communications';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {StubGetCommunications} from 'data/usecases/private/communications/stub-get-communications';
import {StubGetCommunicationsWithBadRequestError} from 'data/usecases/private/communications/stub-get-communications-with-bad-request-error';
import {StubGetCommunicationsWithNotFoundError} from 'data/usecases/private/communications/stub-get-communications-with-not-found-error';
import {communicationsFlowEndpoints} from '../../endpoints';

export const makeGetCommunications = (): GetCommunications =>
	new RemoteGetCommunications(
		makeBFFApiUrl(communicationsFlowEndpoints.communications),
		makeAuthorizeHttpClientDecorator(),
	);

export const mockedMakeGetCommunications = (): GetCommunications => new StubGetCommunications();

export const mockedMakeGetCommunicationsWithBadRequestError = (): GetCommunications =>
	new StubGetCommunicationsWithBadRequestError();

export const mockedMakeGetCommunicationsWithNotFoundError = (): GetCommunications =>
	new StubGetCommunicationsWithNotFoundError();
